"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { SingleWaveDropHeader } from "./SingleWaveDropHeader";
import { SingleWaveDropChat } from "./SingleWaveDropChat";
import { SingleWaveDropTab } from "./SingleWaveDrop";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDrop } from "@/hooks/useDrop";
import { useWaveData } from "@/hooks/useWaveData";
import { MemesSingleWaveDropInfoPanel } from "./MemesSingleWaveDropInfoPanel";
import { useRouter, usePathname } from "next/navigation";
interface MemesSingleWaveDropProps {
  readonly drop: ExtendedDrop;
  readonly onClose: () => void;
}
export const MemesSingleWaveDrop: React.FC<MemesSingleWaveDropProps> = t0 => {
  const $ = _c(30);
  const {
    drop: initialDrop,
    onClose
  } = t0;
  const router = useRouter();
  const pathname = usePathname() ?? "";
  let t1;
  if ($[0] !== initialDrop.id) {
    t1 = {
      dropId: initialDrop.id
    };
    $[0] = initialDrop.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    drop
  } = useDrop(t1);
  const t2 = drop?.wave.id ?? null;
  let t3;
  if ($[2] !== pathname || $[3] !== router) {
    t3 = () => {
      router.push(pathname);
    };
    $[2] = pathname;
    $[3] = router;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      waveId: t2,
      onWaveNotFound: t3
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data: wave
  } = useWaveData(t4);
  const [activeTab, setActiveTab] = useState(SingleWaveDropTab.INFO);
  let t5;
  if ($[8] !== activeTab || $[9] !== onClose) {
    t5 = <SingleWaveDropHeader activeTab={activeTab} setActiveTab={setActiveTab} onClose={onClose} />;
    $[8] = activeTab;
    $[9] = onClose;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== activeTab || $[12] !== drop || $[13] !== initialDrop.stableHash || $[14] !== initialDrop.stableKey || $[15] !== onClose || $[16] !== wave) {
    t6 = !!drop && !!wave && <MemesSingleWaveDropInfoPanel drop={{
      type: DropSize.FULL,
      ...drop,
      stableHash: initialDrop.stableHash,
      stableKey: initialDrop.stableKey
    }} wave={wave} activeTab={activeTab} onClose={onClose} />;
    $[11] = activeTab;
    $[12] = drop;
    $[13] = initialDrop.stableHash;
    $[14] = initialDrop.stableKey;
    $[15] = onClose;
    $[16] = wave;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const t7 = `${activeTab === SingleWaveDropTab.CHAT ? "tw-flex" : "tw-hidden"} lg:tw-flex lg:tw-flex-1 `;
  let t8;
  if ($[18] !== drop || $[19] !== wave) {
    t8 = wave && drop && <SingleWaveDropChat key={drop.id} wave={wave} drop={drop} />;
    $[18] = drop;
    $[19] = wave;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t6 || $[25] !== t9) {
    t10 = <div className="tw-flex tw-flex-col lg:tw-flex-row tw-flex-1 tw-overflow-hidden">{t6}{t9}</div>;
    $[24] = t6;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t5) {
    t11 = <div className="tw-w-full tw-h-full tw-bg-iron-950 tw-flex tw-flex-col tw-pb-[env(safe-area-inset-bottom,0px)]">{t5}{t10}</div>;
    $[27] = t10;
    $[28] = t5;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};